import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { singleAuctionDetails } from "../../../../../redux/action/singleAuction";
import AuctionSchedule from "../../../../sellerAuction/dashboard/comman/AuctionSchedule";
import { getSingleOfferForBuyer } from "../../../../../redux/action/singleBrand";
import ScrapDetails from "./ScrapDetails";
import ServiceScrapDetail from "./ServiceScrapDetail";
import ProductScrapDetails from "./ProductScrapDetails";

function OfferDetails() {
    const { id, offerId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { singleOfferData, loadings } = useSelector((pre) => pre?.singleBrand);
    const { singleAuctionData, loading } = useSelector(
        (pre) => pre?.singleAuction
    );

    useEffect(() => {
        dispatch(singleAuctionDetails(id));
        dispatch(getSingleOfferForBuyer(offerId));
    }, [dispatch, offerId, id]);

    return (
        <div className="flex column gap-10px">
            <span className={`valign-wrapper gap-1`}>
                <span
                    className="material-icons-outlined pointer"
                    onClick={() => navigate(-1)}
                >
                    arrow_back
                </span>
                <h4>Lots Details</h4>
            </span>

            <AuctionSchedule
                singleAuctionData={singleAuctionData}
                loading={loading}
            />
            <div className="full-width mt-2">
                {singleAuctionData?.auctionType === "reverseAuctionService" ? (
                    <ServiceScrapDetail loadings={loadings} singleOfferData={singleOfferData} />
                ) : singleAuctionData?.auctionType === "reverseAuctionProduct" ? (
                    <ProductScrapDetails loadings={loadings} singleOfferData={singleOfferData} />
                ) : (
                    <ScrapDetails loadings={loadings} singleOfferData={singleOfferData} />
                )}
            </div>
        </div>
    );
}

export default OfferDetails;
